export default "__VITE_ASSET__BYMz63Wk__"